<template>

  <div class="advantages" :style="customStyle" style="">
    <div class="advantage">
      <div class="flet">
        <img src="./youshi.png" alt="优势一" class="advantage-icon">
        <div class="advantage-title">优势一</div>
      </div>
      <div class="advantage-content flet">
        <h3>申请流程随时沟通，进度实时掌握</h3>
        <p>全程沟通办理流程，申请进度到哪一步，实时掌握，专业人员一对一跟踪项目进度。</p>
      </div>
    </div>

    <div class="advantage">
      <div class="flet">
        <img src="./youshi.png" alt="优势二" class="advantage-icon">
        <div class="advantage-title">优势二</div>
      </div>
      <div class="advantage-content flet">
        <h3>明码标价，价格透明</h3>
        <p>价格白纸黑字写进合同里，申请成功不会另外收费。</p>
      </div>
    </div>

    <div class="advantage">
      <div class="flet">
        <img src="./youshi.png" alt="优势三" class="advantage-icon">
        <div class="advantage-title">优势三</div>
      </div>
      <div class="advantage-content flet">
        <h3>SSS级资料保密系统，0泄露</h3>
        <p>安贝森的资料保密系统，安全无忧。</p>
      </div>
    </div>
  </div>


</template>
<style scoped>
</style>
<script>
export default {
  props: {
    customStyle: {
      type: Object,
      default: () => ({}) // 默认为空对象
    }
  },
  components: {},
  data() {
    return {}
  },
}
</script>
<style>

.advantages {
  flex-wrap: wrap;
  justify-content: space-around;
}

/*优势*/
.advantage {
  width: 100%;
  position: relative; /* 父容器需要设置为相对定位 */
  margin: 10px;
  padding: 20px;
  border-radius: 8px;
  overflow: hidden; /* 确保内容不会溢出 */
}


.flet {
  float: left;
}

.advantage-icon {
  width: 84px;
  height: 84px;
  display: block;
}

.advantage-title {
  position: absolute;
  top: 10px;
  left: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  padding: 21px 30px;
  border-radius: 5px;
}

.advantage-content {
  width: 80%;
  position: relative; /* 确保此元素的内容不会被绝对定位的标题遮挡 */
  z-index: 1; /* 确保内容在标题之下 */
  margin-left: 20px;
  margin-top: 7px;
}


.advantage-content h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #0788dc;
}

.advantage-content p {
  font-size: 14px;
  color: #666;
}

</style>



// WEBPACK FOOTER //
// src/pages/service/common/advantageList.vue